// ===================== APPROVE ACCOUNT REQUEST FLOW =====================

var _approveReqId = null;
var _approveReqData = null;
var _approveFormShops = [];


function openApproveConfirmModal(uid) {
  _approveReqId = uid;
  _approveReqData = _usersReq.find(function(u){ return (u._id||u.id) === uid; });
  if(!_approveReqData) return;
  
  var name = _approveReqData.name || _approveReqData.legalName || 'this user';
  var requestType = _approveReqData.requestType || 'creation';

  var modal = document.getElementById('modal-approve-confirm');
  if(!modal) {
    modal = document.createElement('div');
    modal.id = 'modal-approve-confirm';
    modal.className = 'modal-overlay';
    document.body.appendChild(modal);
  }
  var message = requestType === 'deletion'
    ? `Approve deletion for <strong style="color:var(--text-primary)">${escHtml(name)}</strong>?<br><br>
       This user account will be processed according to your deletion workflow.`
    : `Approve the new account request for <strong style="color:var(--text-primary)">${escHtml(name)}</strong>?<br><br>
       You will set a temporary password on the next screen.`;

  modal.innerHTML = `
    <div class="modal-box" style="max-width:420px">
      <div class="modal-header">
        <div class="modal-title">Approve Request</div>
        <button class="modal-close" onclick="closeApproveConfirmModal()">×</button>
      </div>

      <div style="padding:16px 0;color:var(--text-secondary);line-height:1.6;">
        ${message}
      </div>

      <div class="modal-footer">
        <button class="action-btn secondary" onclick="closeApproveConfirmModal()">Cancel</button>
        <button class="action-btn primary" onclick="handleApproveConfirm()">Approve</button>
      </div>
    </div>
  `;
  
  modal.classList.add('active');
}
async function handleApproveConfirm() {
  var r = _approveReqData;
  // console.log('Approved Request data:', _approveReqData);
  if(!r) return;

  var requestType = r.requestType || 'creation';

  closeApproveConfirmModal();
 if(requestType === 'deletion') {
    try {
      await apiPost('/account-requests/' + _approveReqId + '/approve', {}, true)
      var deletedId = _approveReqId;
      _usersReq = _usersReq.filter(function(u){ return (u._id||u.id) !== deletedId; });
      _users    = _users.filter(function(u){ return (u._id||u.id) !== deletedId; });
      
      _approveReqId   = null;
      _approveReqData = null;
      renderUsersAllWithDetail(applyUsersFilters(_users));
      renderUsersRequested(_usersReq);

      LOADED.users = false;
      loadUsers();
      var modal = document.getElementById('modal-approve-confirm');
      if(modal) modal.classList.remove('active');

      showView('users');
      usersSubTab('requested');

    } catch(e) {
      alert('Failed to approve request');
    }
    return;
  }
  goToApproveForm();
}

function closeApproveConfirmModal() {
  var modal = document.getElementById('modal-approve-confirm');
  if(modal) modal.classList.remove('active');
}

async function goToApproveForm() {
  closeApproveConfirmModal();
  
  var r = _approveReqData;
  if(!r) return;
  
  _approveFormShops = [];
  try {
    var shopsData = await api('/shops', true);
    _approveFormShops = Array.isArray(shopsData) ? shopsData : (shopsData && shopsData.shops ? shopsData.shops : []);
  } catch(e) {}
  
  renderApproveFormView();
}

function handleApproveUserTypeChange(value) {
  var shopGroup = document.getElementById('apf-shop-group');
  if (shopGroup) {
    shopGroup.style.display = value === 'customer' ? 'block' : 'none';
  }
}

function renderApproveFormView() {
  var r = _approveReqData;
  if(!r) return;
  
  var name = r.name || r.legalName || '';
  var email = r.email || '';
  var phone = r.phoneNumber || '';
  var location = r.location || '';
  var userType = r.userType || 'customer';
  var typeDisplay = userType === 'salesRep' ? 'Sales Rep' : 'Customer';
  
  var shopsOptions = '<option value="" disabled selected>Select shop</option>' +
    _approveFormShops.map(function(s){
      return '<option value="'+(s._id||s.id)+'">'+escHtml(s.shopName)+'</option>';
    }).join('');
  
  showView('user-detail');
  
  var content = document.getElementById('user-detail-content');
  content.innerHTML = `
    <div style="max-width:520px;margin:0 auto">
      
      <div style="margin-bottom:20px">
        <button class="action-btn secondary" onclick="backFromApproveForm()">← Back</button>
      </div>
      
      <h2 style="color:var(--text-primary);margin-bottom:20px;font-size:20px;">Approve Account</h2>
      
      <!-- Name -->
      <div class="form-group">
        <div class="form-label">Full Name *</div>
        <input class="form-input" id="apf-name" type="text" value="${escHtml(name)}" autocomplete="off">
      </div>
      
      <!-- Email (readonly) -->
      <div class="form-group">
        <div class="form-label">Email</div>
        <input class="form-input" id="apf-email" type="email" value="${escHtml(email)}" readonly
          style="background:var(--border-light);color:var(--text-muted);cursor:not-allowed">
        <div style="font-size:11px;color:var(--text-muted);margin-top:4px">Email cannot be changed</div>
      </div>
      
      <!-- Temporary Password -->
      <div class="form-group">
        <div class="form-label">Temporary Password *</div>
        <div class="input-wrap">
          <input class="form-input with-icon" id="apf-pass" type="password" 
            placeholder="Set temporary password" autocomplete="new-password">
          <button class="eye-btn" onclick="toggleEye('apf-pass',this)">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
            </svg>
          </button>
        </div>
        <div style="font-size:11px;color:var(--text-muted);margin-top:4px">
          Must have uppercase, lowercase, number, and special character
        </div>
      </div>
      
      <!-- Phone -->
      <div class="form-group">
        <div class="form-label">Phone Number</div>
        <input class="form-input" id="apf-phone" type="tel" 
          value="${escHtml(phone)}" placeholder="Phone number (optional)" autocomplete="off">
      </div>
      
      <!-- Location -->
      <div class="form-group">
        <div class="form-label">Address</div>
        <textarea class="form-input" id="apf-location" rows="2" style="resize:none"
          placeholder="Address">${escHtml(location)}</textarea>
      </div>
      
      <!-- User Type (readonly) -->
     <!-- User Type Dropdown -->
<div class="form-group">
  <div class="form-label">User Type *</div>
  <select class="form-input" id="apf-type" onchange="handleApproveUserTypeChange(this.value)">
    <option value="" disabled ${!userType ? 'selected' : ''}>Select user type</option>
    <option value="customer" ${userType === 'customer' ? 'selected' : ''}>Customer</option>
    <option value="salesRep" ${userType === 'salesRep' ? 'selected' : ''}>Sales Rep</option>
  </select>
</div>
      
      <!-- Shop (only for customer) -->
      ${userType === 'customer' ? `
        <div class="form-group" id="apf-shop-group" style="display: ${userType === 'customer' ? 'block' : 'none'}">
  <div class="form-label">Shop *</div>
  <select class="form-input" id="apf-shop">
    <option value="" disabled selected>Select shop</option>
    ${_approveFormShops.map(function(s){
      return '<option value="'+(s._id||s.id)+'">'+escHtml(s.shopName)+'</option>';
    }).join('')}
  </select>
  <button type="button" class="add-address-btn" onclick="openAddShopFromApprove()" style="margin-top:8px">
    <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
    </svg>
    Add New Shop
  </button>
</div>
      ` : ''}
      
      <div class="form-error" id="apf-error"></div>
      
      <div class="modal-footer" style="padding:0;margin-top:16px">
        <button class="action-btn primary" id="apf-submit-btn" 
          onclick="submitApproveUser()" style="width:100%;padding:14px">
          Add User
        </button>
      </div>
      
    </div>
  `;
}

function backFromApproveForm() {
  if(_approveReqId) {
    openUserDetail(_approveReqId, true);
  } else {
    showView('users');
  }
}

function openAddShopFromApprove() {
  window._approveFormReturnContext = true;
  openAddShop();
}
async function submitEditUser(){
  var name = document.getElementById('eu-name').value.trim();
  var email = document.getElementById('eu-email').value.trim();
  var phone = document.getElementById('eu-phone').value.trim();
  var location = document.getElementById('eu-location').value.trim();
  var status = document.getElementById('eu-status').value;
  var type = document.getElementById('eu-type').value;
  var shopEl = document.getElementById('eu-shop');
  var shopId = shopEl ? shopEl.value : '';
  var errEl = document.getElementById('eu-error');
  var shopErrEl = document.getElementById('eu-shop-error');

  errEl.textContent = '';
  shopErrEl.textContent = '';

  if(!name || !email || !type){
    errEl.textContent = 'Please fill all required fields.'; 
    return;
  }

  if(name.length < 2){ 
    errEl.textContent = 'Name must be at least 2 characters'; 
    return; 
  }

  var phoneDigits = phone.replace(/\D/g, '');

  if (phone) {
    if (phoneDigits.length > 10) {
      errEl.textContent = 'Phone number cannot be more than 10 digits.';
      return;
    }
    if (phoneDigits.length < 10) {
      errEl.textContent = 'Phone number must be 10 digits.';
      return;
    }
  }

  if(type === 'customer'){
    if(!shopId){
      shopErrEl.textContent = 'Shop is required for customer users';
      return;
    }

    try{
      var shop = await api('/shops/'+shopId, true);
      var team = shop ? effectiveShopSalesRepIds(shop) : [];

      if(team.length === 0){
        shopErrEl.textContent = 'This shop has no sales rep. Assign one in Edit shop first.';
        return;
      }

      if(team.length > 1){
        shopErrEl.textContent = 'This shop has multiple sales reps. Edit the shop so it has exactly one.';
        return;
      }

    }catch(e){
      shopErrEl.textContent = 'Could not validate shop.';
      return;
    }

    shopErrEl.textContent = '';
  }

  var btn = document.getElementById('eu-submit-btn');
  var originalText = btn.textContent;
  btn.textContent = 'Updating...'; 
  btn.disabled = true;

  try {
    var payload = {
      legalName: name,
      email: email.toLowerCase(),
      role: type,
      isActive: status === 'Active'
    };

    if(type === 'customer' && shopId) payload.shopId = shopId;
    if (phoneDigits.length === 10) {
      payload.phoneNumber = phoneDigits;
    }

    if(location){
      payload.addresses = {
        addressLine1: location,
        city: 'N/A',
        state: 'N/A',
        postalCode: '00000',
        country: 'US',
        isPrimary: true
      };
    }

    var res = await apiPatch('/users/'+_currentUserId, payload, true);

    btn.textContent = originalText; 
    btn.disabled = false;

    if(res && (res.success || res._id || res.id || res.email)){
      closeModal('modal-edit-user');
      LOADED.users = false;
      loadUsers();

      if(document.getElementById('view-user-detail').style.display !== 'none'){
        openUserDetail(_currentUserId);
      }

    }else{
      var errMsg = '';
      if(res){
        if(typeof res.message === 'string') errMsg = res.message;
        else if(Array.isArray(res.message)) errMsg = res.message.join(' ');
        else if(res.error && typeof res.error === 'string') errMsg = res.error;
      }
      errEl.textContent = errMsg || 'Failed to update user.';
    }

  } catch (err) {
    console.error('Update user error:', err);
    errEl.textContent = 'Failed to update user.';
    btn.textContent = originalText;
    btn.disabled = false;
  }
}

async function submitApproveUser() {
  var r = _approveReqData;
  if (!r) return;

  var name     = document.getElementById('apf-name').value.trim();
  var email    = document.getElementById('apf-email').value.trim();
  var pass     = document.getElementById('apf-pass').value;
  var phone    = document.getElementById('apf-phone').value.trim();
  var location = document.getElementById('apf-location').value.trim();
  var userType = document.getElementById('apf-type').value;
  var shopEl   = document.getElementById('apf-shop');
  var shopId   = shopEl ? shopEl.value : '';
  var errEl    = document.getElementById('apf-error');
  var btn      = document.getElementById('apf-submit-btn');

  errEl.textContent = '';

  // ================= VALIDATION =================
  if (!name) return errEl.textContent = 'Please enter full name.';
  if (!email) return errEl.textContent = 'Email is required.';
  if (!pass) return errEl.textContent = 'Please set a temporary password.';

  var strong = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/;
  if (!strong.test(pass)) {
    return errEl.textContent =
      'Password must include uppercase, lowercase, number, and special character.';
  }

  if (!userType) return errEl.textContent = 'Please select user type.';
  if (userType === 'customer' && !shopId) {
    return errEl.textContent = 'Please select a shop for this customer.';
  }

  // ✅ PHONE VALIDATION (CORRECT PLACE)
  var phoneDigits = phone.replace(/\D/g, '');

  if (phone.trim() && phoneDigits.length > 10) {
    errEl.textContent = 'Phone number cannot be more than 10 digits.';
    return;
  }

  if (phone.trim() && phoneDigits.length < 10) {
    errEl.textContent = 'Phone number must be 10 digits.';
    return;
  }

  // ================= LOADER =================
  btn.textContent = 'Creating...';
  btn.disabled = true;

  try {
    // ================= PAYLOAD =================
    var payload = {
      legalName: name,
      email: email.toLowerCase(),
      temporaryPassword: pass,
      role: userType
    };

    if (shopId) payload.shopId = shopId;

    // ✅ assign AFTER validation
   if(phoneDigits.length === 10) payload.phoneNumber = phoneDigits;

    if (location) {
      payload.addresses = {
        addressLine1: location,
        city: 'N/A',
        state: 'N/A',
        postalCode: '00000',
        country: 'US',
        isPrimary: true
      };
    }

    // ================= CREATE USER =================
    var userRes = await apiPost('/users/create-by-admin', payload, true);

    if (!userRes || (!userRes._id && !userRes.id)) {
      throw new Error(
        (userRes && userRes.message) || 'Failed to create user'
      );
    }

    var newUserId = userRes._id || userRes.id;

    // ================= MARK APPROVED =================
    try {
      await apiPatch(
        '/account-requests/' + _approveReqId + '/mark-approved',
        newUserId ? { userId: newUserId } : {},
        true
      );
    } catch (e) {
      console.warn('mark-approved failed:', e?.message || e);
    }

    // ================= SUCCESS =================
    showApproveSuccessModal();

    LOADED.users = false;
    loadUsers();

  } catch (err) {
    console.error('Create user error:', err);

    var message =
      err?.response?.data?.message ||
      err?.message ||
      'Failed to create user';

    if (Array.isArray(message)) message = message.join(' ');

    errEl.textContent = message;

    btn.textContent = 'Add User';
    btn.disabled = false;
  }
}

function showApproveSuccessModal() {
  var modal = document.getElementById('modal-approve-success');
  if(!modal) {
    modal = document.createElement('div');
    modal.id = 'modal-approve-success';
    modal.className = 'modal-overlay';
    document.body.appendChild(modal);
  }
  
  modal.innerHTML = `
    <div class="modal-box" style="max-width:380px;text-align:center">
      <div style="padding:32px 24px">
        <div style="font-size:48px;margin-bottom:16px">✅</div>
        <div style="font-size:18px;font-weight:700;color:var(--text-primary);margin-bottom:8px">
          User Created Successfully
        </div>
        <div style="font-size:14px;color:var(--text-secondary);margin-bottom:28px;line-height:1.6">
          The account has been approved and the user has been created.
        </div>
        <button class="action-btn primary" style="width:100%;padding:14px" 
          onclick="closeApproveSuccessModal()">OK</button>
      </div>
    </div>
  `;
  
  modal.classList.add('active');
}

function closeApproveSuccessModal() {
  var modal = document.getElementById('modal-approve-success');
  if(modal) modal.classList.remove('active');

  var approvedId = _approveReqId;
  var approvedData = _approveReqData;
  _usersReq = _usersReq.filter(function(u){ 
    return (u._id||u.id) !== approvedId; 
  });
  if(approvedData) {
    var alreadyExists = _users.some(function(u){ 
      return (u._id||u.id) === approvedId || u.email === approvedData.email; 
    });
    if(!alreadyExists) {
      _users.push({
        _id: approvedId,
        id: approvedId,
        legalName: approvedData.name || approvedData.legalName || '',
        email: approvedData.email || '',
        role: approvedData.userType || 'customer',
        isActive: true,
        mustChangePassword: true  
      });
    }
  }

  _approveReqId = null;
  _approveReqData = null;
  renderUsersAllWithDetail(applyUsersFilters(_users));
  renderUsersRequested(_usersReq);
  document.getElementById('users-count').textContent = _users.length;

  showView('users');
  usersSubTab('all'); 

  // LOADED.users = false;
  // loadUsers(); 
  renderUsersRequested(_usersReq);
}

async function requestAccountDeletionOtp(){
  var res=await apiPost('/users/me/request-account-deletion-otp',{},true);
  return res;
}
async function confirmDeletionRequestOtp(code){
  var res=await apiPost('/users/me/confirm-account-deletion',{code:code.trim()},true);
  return res;
}
async function getMyPendingDeletionStatus(){
  try{
    var res=await api('/account-requests?status=pending',true);
    var list=Array.isArray(res)?res:(res&&res.requests?res.requests:[]);
    var pending=list.some(function(r){return r.requestType==='deletion'||r.request_type==='deletion';});
    return{pending:pending};
  }catch(e){return{pending:false};}
}

async function loadDeletionStatus(){
  var role=(localStorage.getItem('userRole')||'').toLowerCase().trim();
  try{
    var u=JSON.parse(localStorage.getItem('@exhaustexpert_user')||'{}');
    if(u&&u.role)role=u.role.toLowerCase().trim();
  }catch(e){}

  var el=document.getElementById('delete-account-row');

  if(role!=='salesrep'&&role!=='sales_rep'){
    if(el)el.style.display='none';
    return;
  }

  if(el)el.style.display='block';

  _deletionStatusLoading=true;
  renderDeleteAccountRow();

  try{
    var s=await getMyPendingDeletionStatus();
    _pendingDeletionRequest=!!s.pending;
  }catch(e){
    _pendingDeletionRequest=false;
  }finally{
    _deletionStatusLoading=false;
  }

  renderDeleteAccountRow();
}

function renderDeleteAccountRow(){
  var row=document.getElementById('delete-account-row');
  if(!row)return;
  if(_deletionStatusLoading){
    row.innerHTML='<div class="profile-menu-item" style="opacity:0.5"><div class="pmi-left"><div class="pmi-icon"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg></div><div class="pmi-text" style="color:var(--text-muted)">Checking status…</div></div></div>';
    return;
  }
  if(_pendingDeletionRequest){
    row.innerHTML='<div class="profile-menu-item" style="cursor:default"><div class="pmi-left"><div class="pmi-icon"><svg fill="none" stroke="var(--text-muted)" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg></div><div><div class="pmi-text" style="color:var(--text-muted)">Deletion request pending</div><div style="font-size:11px;color:var(--text-muted);margin-top:2px">We will email you when an administrator reviews it.</div></div></div></div>';
    return;
  }
  row.innerHTML='<div class="profile-menu-item" onclick="openDeleteAccountFlow()" style="cursor:pointer"><div class="pmi-left"><div class="pmi-icon"><svg fill="none" stroke="#ff6b6b" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg></div><div class="pmi-text" style="color:#ff6b6b">Delete Account</div></div><div class="pmi-right"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg></div></div>';
}

function openDeleteAccountFlow(){
  if(_isSendingDeleteRequest||_deletionStatusLoading||_pendingDeletionRequest)return;
  openModal('modal-delete-account-confirm');
}
async function handleDeleteConfirmSend(){
  var btn=document.getElementById('del-confirm-send-btn');
  btn.textContent='Sending…';btn.disabled=true;
  closeModal('modal-delete-account-confirm');
  await sendDeletionOtp();
  btn.textContent='Send Code';btn.disabled=false;
}

async function sendDeletionOtp(){
  _isSendingDeleteRequest=true;
  var row=document.getElementById('delete-account-row');
  if(row)row.innerHTML='<div class="profile-menu-item" style="opacity:0.5"><div class="pmi-left"><div class="pmi-icon"><svg fill="none" stroke="#ff6b6b" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg></div><div class="pmi-text" style="color:#ff6b6b">Sending code…</div></div></div>';
  try{
    await requestAccountDeletionOtp();
    openModal('modal-delete-account-otp');
    document.getElementById('del-otp-input').value='';
    document.getElementById('del-otp-error').textContent='';
  }catch(e){
    alert('Could not send verification code. Please try again.');
  }finally{
    _isSendingDeleteRequest=false;
    renderDeleteAccountRow(); 
  }
}
async function submitDeleteAccountOtp(){
  var code=(document.getElementById('del-otp-input').value||'').trim();
  var errEl=document.getElementById('del-otp-error');
  if(code.length!==6){errEl.textContent='Please enter the 6-digit code.';return;}
  errEl.textContent='';
  var btn=document.getElementById('del-otp-submit-btn');
  btn.textContent='Verifying…';btn.disabled=true;
  try{
    var res=await confirmDeletionRequestOtp(code);
    closeModal('modal-delete-account-otp');
    _pendingDeletionRequest=true;
    renderDeleteAccountRow();
    alert(res&&res.message?res.message:'Request submitted. We will email you after an admin reviews your request.');
  }catch(e){
    errEl.textContent='Invalid code or request failed. Please try again.';
  }finally{
    btn.textContent='Verify & Submit';btn.disabled=false;
  }
}

async function resendDeletionOtp(){
  var btn=document.getElementById('del-otp-resend-btn');
  btn.textContent='Sending…';btn.disabled=true;
  try{
    await requestAccountDeletionOtp();
    alert('Code sent. Check your email for a new verification code.');
  }catch(e){
    alert('Could not resend code. Please try again.');
  }finally{
    btn.textContent='Resend code';btn.disabled=false;
  }
}


// ===================== NOTIFICATIONS =====================
async function loadNotifs(){
  var role=(localStorage.getItem('userRole')||'').toLowerCase().trim();
  try{var _nu=JSON.parse(localStorage.getItem('@exhaustexpert_user')||'{}');if(_nu&&_nu.role)role=_nu.role.toLowerCase().trim();}catch(e){}
  var isSalesRep=(role==='salesrep'||role==='sales_rep');

  var endpoint=isSalesRep?'/notifications/me':'/notifications/admin';
  var data=await api(endpoint,true);
  _notifs=Array.isArray(data)?data:(data&&data.notifications?data.notifications:[]);
  var unread=_notifs.filter(function(n){return!n.read;}).length;
  var badge=document.getElementById('notif-badge');
  if(unread>0){badge.style.display='flex';badge.textContent=unread>99?'99+':unread;}else badge.style.display='none';
  renderNotifs();
}
// function renderNotifs(){
//   var body = document.getElementById('notif-body');
//   if(!_notifs.length){
//     body.innerHTML = '<div class="empty-state"><span class="empty-icon">🔔</span><p>No notifications</p></div>';
//     return;
//   }
  
//   var trashIcon = '<svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>';
  
//   body.innerHTML = _notifs.map(function(n){
//     var msg = n.body || n.message || '';
//     var isUnread = !n.read;
    
//     var clickHandler = "handleNotifClick('"+n.id+"','"+encodeURIComponent(JSON.stringify(n))+"')";
    
//     return '<div class="notif-item '+(isUnread?'unread':'')+'" style="cursor:pointer" onclick="'+clickHandler+'">'+

//       '<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:6px;">'+
//         '<div class="notif-ttl" style="font-size:14px;font-weight:600;color:var(--text-primary);margin:0;">'+n.title+'</div>'+
//         '<button class="notif-del-icon" onclick="event.stopPropagation();delNotif(\''+n.id+'\')" style="background:none;border:none;cursor:pointer;color:var(--text-muted);padding:4px;border-radius:4px;display:flex;align-items:center;" title="Delete">'+trashIcon+'</button>'+
//       '</div>'+
//       '<div class="notif-row">'+
//         '<div class="notif-icon"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/></svg></div>'+
//         '<div><div class="notif-msg">'+msg+'</div></div>'+
//       '</div>'+
//       '<div class="notif-time">'+n.time+'</div>'+
//       '</div>';
//   }).join('');
// }
function renderNotifs(){
  var body = document.getElementById('notif-body');
  if(!_notifs.length){
    body.innerHTML = '<div class="empty-state"><span class="empty-icon">🔔</span><p>No notifications</p></div>';
    // Remove modal if open
    var m = document.getElementById('bulk-action-modal');
    if(m) m.remove();
    return;
  }
  
  var trashIcon = '<svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>';
  
  // 🔹 Bulk Action Buttons
  var bulkBtns = `
    <div style="display:flex;gap:8px;padding:10px 14px;border-bottom:1px solid var(--border-light);margin-bottom:4px;">
      <button onclick="showBulkActionModal('markAll')" style="flex:1;padding:6px 0;border:1px solid var(--sidebar-accent2);border-radius:6px;background:transparent;color:var(--sidebar-accent2);font-size:12px;font-weight:600;cursor:pointer;${_bulkActionModal.loading?'opacity:0.5;':''}" ${_bulkActionModal.loading?'disabled':''}>
        ${_bulkActionModal.loading && _bulkActionModal.type==='markAll' ? 'Processing...' : 'Mark all as read'}
      </button>
      <button onclick="showBulkActionModal('deleteAll')" style="flex:1;padding:6px 0;border:1px solid var(--chart-red);border-radius:6px;background:transparent;color:var(--chart-red);font-size:12px;font-weight:600;cursor:pointer;${_bulkActionModal.loading?'opacity:0.5;':''}" ${_bulkActionModal.loading?'disabled':''}>
        ${_bulkActionModal.loading && _bulkActionModal.type==='deleteAll' ? 'Processing...' : 'Delete all'}
      </button>
    </div>
  `;

  var listHTML = _notifs.map(function(n){
    var msg = n.body || n.message || '';
    var isUnread = !n.read;
    var clickHandler = "handleNotifClick('"+n.id+"','"+encodeURIComponent(JSON.stringify(n))+"')";
    return '<div class="notif-item '+(isUnread?'unread':'')+'" style="cursor:pointer" onclick="'+clickHandler+'">'+
      '<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:6px;">'+
        '<div class="notif-ttl" style="font-size:14px;font-weight:600;color:var(--text-primary);margin:0;">'+n.title+'</div>'+
        '<button class="notif-del-icon" onclick="event.stopPropagation();delNotif(\''+n.id+'\')" style="background:none;border:none;cursor:pointer;color:var(--text-muted);padding:4px;border-radius:4px;display:flex;align-items:center;" title="Delete">'+trashIcon+'</button>'+
      '</div>'+
      '<div class="notif-row">'+
        '<div class="notif-icon"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/></svg></div>'+
        '<div><div class="notif-msg">'+msg+'</div></div>'+
      '</div>'+
      '<div class="notif-time">'+n.time+'</div>'+
      '</div>';
  }).join('');

  body.innerHTML = bulkBtns + listHTML;
  renderBulkActionModal();
}
/* ─────────────────────────────────────────────
   BULK ACTION MODAL HANDLERS
───────────────────────────────────────────── */
function renderBulkActionModal() {
  var existing = document.getElementById('bulk-action-modal');
  if(existing) existing.remove();
  if(!_bulkActionModal.show) return;

  var isDel = _bulkActionModal.type === 'deleteAll';
  var html = `
    <div id="bulk-action-modal" style="position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);z-index:4000;display:flex;align-items:center;justify-content:center" onclick="closeBulkActionModal()">
      <div style="background:#fff;border-radius:12px;padding:24px;width:85%;max-width:320px;box-shadow:0 8px 24px rgba(0,0,0,0.18)" onclick="event.stopPropagation()">
        <p style="font-size:16px;font-weight:700;color:#1a2a2a;text-align:center;margin:0 0 8px">${isDel ? 'Delete all notifications?' : 'Mark all as read?'}</p>
        <p style="font-size:13px;color:#666;text-align:center;margin:0 0 20px;line-height:1.4">${isDel ? 'This action cannot be undone. All your notifications will be permanently deleted.' : 'All unread notifications will be marked as read.'}</p>
        <div style="display:flex;gap:10px">
          <button onclick="closeBulkActionModal()" style="flex:1;padding:10px;border:1px solid #ddd;border-radius:8px;background:#fff;font-size:14px;font-weight:600;color:#555;cursor:pointer">Cancel</button>
          <button onclick="confirmBulkAction()" style="flex:1;padding:10px;border:none;border-radius:8px;background:${isDel ? 'var(--chart-red)' : 'var(--sidebar-accent2)'};font-size:14px;font-weight:600;color:#fff;cursor:pointer" ${_bulkActionModal.loading?'disabled':''}>${_bulkActionModal.loading ? 'Processing...' : (isDel ? 'Delete' : 'Mark as read')}</button>
        </div>
      </div>
    </div>
  `;
  document.body.insertAdjacentHTML('beforeend', html);
}

function showBulkActionModal(type) {
  _bulkActionModal = { show: true, type: type, loading: false };
  renderNotifs();
}

function closeBulkActionModal() {
  _bulkActionModal = { show: false, type: null, loading: false };
  var m = document.getElementById('bulk-action-modal');
  if(m) m.remove();
  renderNotifs();
}

async function confirmBulkAction() {
  var type = _bulkActionModal.type;
  if(!type) return;
  
  var role = getCurrentUserRole();
  var isSalesRep = (role === 'salesrep' || role === 'sales_rep');
  
  _bulkActionModal.loading = true;
  renderNotifs();

  var prevNotifs = _notifs.slice();
  // Optimistic UI update
  if(type === 'markAll') _notifs = _notifs.map(n => ({...n, read: true}));
  else _notifs = [];
  updateNotifBadge();

  try {
    var endpoint = type === 'markAll' 
      ? (isSalesRep ? '/notifications/me/mark-all-read' : '/notifications/admin/mark-all-read')
      : (isSalesRep ? '/notifications/me/all' : '/notifications/admin/all');
      
    if(type === 'markAll') await apiPatch(endpoint, {}, true);
    else await apiDelete(endpoint, true);
    
    // Toast/Alert
    if(typeof showToast === 'function') showToast(type === 'markAll' ? 'All marked as read' : 'All notifications deleted');
    else alert(type === 'markAll' ? 'All notifications marked as read' : 'All notifications deleted');
    
  } catch(e) {
    _notifs = prevNotifs;
    updateNotifBadge();
    if(typeof showToast === 'function') showToast('Action failed. Please try again.');
    else alert('Action failed. Please try again.');
  } finally {
    closeBulkActionModal();
  }
}
// ===================== NOTIFICATION CLICK HANDLER =====================
async function handleNotifClick(notifId, notifJson){
  var n;
  try{ n = JSON.parse(decodeURIComponent(notifJson)); }catch(e){ n = _notifs.find(function(x){return x.id===notifId;}); }
  if(!n) return;
  
  if(!n.read) await markRead(notifId);
  
  var kind = String(n.kind || '').trim();
  var data = (n.data && typeof n.data === 'object') ? n.data : {};
  
  var closeAfterNav = function(){
    var panel = document.getElementById('notif-panel');
    var overlay = document.getElementById('notif-overlay');
    if(panel) panel.classList.remove('active');
    if(overlay) overlay.classList.remove('active');
  };
  
  if(kind.startsWith('ORDER_')){
    var orderId = String(data.orderId || '').trim();
    if(orderId){
      await navigateToOrder(orderId);
      closeAfterNav(); 
      return;
    }else{
      var text = (n.title||'')+' '+(n.body||'');
      var orderNum = parseOrderNumberFromText(text);
      if(orderNum){
        try{
          var list = await api('/admin/orders?limit=200&search='+encodeURIComponent('Order #'+orderNum), true);
          var found = Array.isArray(list)?list.find(function(o){return String(o.orderNumber||'').includes('Order #'+orderNum);}):null;
          if(found && found.id){ await navigateToOrder(found.id); closeAfterNav(); return; }
        }catch(e){}
      }
      showView('orders');
      if(!LOADED.orders){ LOADED.orders = true; loadOrders(); }
      closeAfterNav(); 
      return;
    }
  }
  
  if(kind === 'RMA_REQUESTED' || kind === 'RMA_UPDATED'){
    var rmaId = String(data.rmaId || '').trim();
    if(rmaId){
      await navigateToRMA(rmaId);
      closeAfterNav(); 
      return;
    }else{
      var text = (n.title||'')+' '+(n.body||'');
      var rmaToken = parseRmaTokenFromText(text);
      if(rmaToken){
        try{
          var list = await api('/admin/rmas?status=all', true);
          var found = Array.isArray(list)?list.find(function(r){return String(r.rmaNumber||'').toLowerCase()===rmaToken.toLowerCase()}):null;
          if(found && (found.id || found._id)){ await navigateToRMA(found.id || found._id); closeAfterNav(); return; }
        }catch(e){}
      }
      window.location.href = 'dashboard.html?tab=dashboard';
      closeAfterNav(); 
      return;
    }
  }
  
  if(kind === 'SUPPORT_TICKET_UPDATED'){
    var ticketId = String(data.ticketId || '').trim();
    if(ticketId){
      await navigateToTicket(ticketId);
      closeAfterNav(); 
      return;
    }else{
      window.location.href = 'dashboard.html?tab=dashboard';
      closeAfterNav(); 
      return;
    }
  }
  closeAfterNav();
}
// ===================== NOTIFICATION NAVIGATION HELPERS =====================
async function navigateToOrder(orderId) {
  if (!orderId) return;
  window.location.hash = 'order-detail/' + orderId;
  showView('orders');
  if (!LOADED.orders) { LOADED.orders = true; await loadOrders(); }
  await openOrderDetail(orderId);
}

async function navigateToRMA(rmaId) {
  if (!rmaId) return;
  window.location.hash = 'rma-detail/' + rmaId;
  showView('rma');
  if (!LOADED.rma) { LOADED.rma = true; await loadRMA(); }
  await openRMADetail(rmaId);
}

async function navigateToTicket(ticketId) {
  if (!ticketId) return;
  window.location.hash = 'support-detail/' + ticketId;
  showView('support');
  if (!LOADED.support) { LOADED.support = true; await loadSupport(); }
  await openSupportDetail(ticketId);
}

function toggleNotif(){
  var panel = document.getElementById('notif-panel');
  var overlay = document.getElementById('notif-overlay');
  var isActive = panel.classList.toggle('active');
  overlay.classList.toggle('active', isActive);
  
  if(isActive){
    loadNotifs();
  }
}
async function markRead(id){
  // 🔹 Get current role (same logic as loadNotifs)
  var role = (localStorage.getItem('userRole') || '').toLowerCase().trim();
  try { var _nu = JSON.parse(localStorage.getItem('@exhaustexpert_user')||'{}'); if(_nu && _nu.role) role = _nu.role.toLowerCase().trim(); } catch(e) {}
  var isSalesRep = (role === 'salesrep' || role === 'salesRep');
  
  // 🔹 Use role-based endpoint
  var endpoint = isSalesRep 
    ? '/notifications/me/' + id + '/read' 
    : '/notifications/admin/' + id + '/read';
  
  var n = _notifs.find(function(x){ return x.id === id; });
  
  // 🔹 Optimistic UI update FIRST
  if(n && !n.read){
    n.read = true;
    renderNotifs();      // Re-renders list with "read" style
    updateNotifBadge();  // Drops badge count immediately
  }
  
  // 🔹 Then sync with backend
  try {
    await apiPatch(endpoint, {}, true);
  } catch(err) {
    // 🔹 If API fails, revert local change
    if(n) n.read = false;
    renderNotifs();
    updateNotifBadge();
    console.error('Mark read failed:', err);
  }
}

function updateNotifBadge(){
  var unread = _notifs.filter(function(x){return !x.read;}).length;
  var badge = document.getElementById('notif-badge');
  if(unread > 0){
    badge.style.display = 'flex';
    badge.textContent = unread > 99 ? '99+' : unread;
  }else{
    badge.style.display = 'none';
  }
}
async function delNotif(id){
  var idx = _notifs.findIndex(function(x){return x.id===id;});
  if(idx > -1) _notifs.splice(idx, 1);
  renderNotifs();
  updateNotifBadge();
  
  try{
    await apiDelete('/notifications/admin/'+id, true);
  }catch(err){
    console.error('Delete failed:', err);
    alert('Failed to delete notification');
    loadNotifs(); 
  }
}
function applyRoleAccess() {
  const role = localStorage.getItem('userRole');
  const productTab = document.getElementById('snav-products');

  if (!productTab) return;
const isWHAdmin = (role === 'warehouseadmin' || role === 'warehouseAdmin');

  if (role !== 'admin' && !isWHAdmin) {
    productTab.closest('li').style.display = 'none';
  } else {
    productTab.closest('li').style.display = ''; // ensure it's visible
  }
}
// ✅ Download Receipt using jsPDF + html2canvas
async function downloadOrderReceipt(orderId){
  if(typeof window.jspdf==='undefined'||typeof window.html2canvas==='undefined'){
    alert('PDF libraries loading... Please try again in a moment.');return;
  }
  var {jsPDF}=window.jspdf;
  var contentDiv=document.getElementById('order-detail-content');
  var btns=contentDiv.querySelectorAll('button');
  btns.forEach(function(b){if(b.textContent.includes('Receipt'))b.style.display='none';});
  var thankDiv=document.createElement('div');
  thankDiv.id='pdf-thankyou';
  thankDiv.innerHTML='<div style="margin-top:40px;padding:24px;text-align:center;border-top:2px dashed #2a2f45;background:rgba(0,212,170,0.05);border-radius:12px;"><p style="font-size:18px;font-weight:700;color:#00d4aa;margin:0;">Thank you for your order.</p><p style="font-size:14px;color:#545870;margin:8px 0 0 0;">- Exhaust Expert</p><p style="font-size:11px;color:#545870;margin:12px 0 0 0;opacity:0.7;">'+new Date().toLocaleString()+'</p></div>';
  contentDiv.appendChild(thankDiv);
  try{
    var canvas=await html2canvas(contentDiv,{backgroundColor:'#0f1117',scale:2,useCORS:true,logging:false,windowHeight:contentDiv.scrollHeight+100});
    var imgData=canvas.toDataURL('image/png');
    var pdf=new jsPDF('p','mm','a4');
    var pdfWidth=pdf.internal.pageSize.getWidth();
    var pdfHeight=pdf.internal.pageSize.getHeight();
    var scaledWidth=pdfWidth-20;
    var scaledHeight=(canvas.height/canvas.width)*scaledWidth;
    var heightLeft=scaledHeight;var position=10;
    pdf.addImage(imgData,'PNG',10,position,scaledWidth,scaledHeight);
    heightLeft-=(pdfHeight-20);
    while(heightLeft>0){position=heightLeft-scaledHeight+10;pdf.addPage();pdf.addImage(imgData,'PNG',10,position,scaledWidth,scaledHeight);heightLeft-=(pdfHeight-20);}
    pdf.save('Order_Receipt_'+orderId+'.pdf');
  }catch(err){console.error('PDF error:',err);alert('Failed to generate PDF.');}
  finally{
    var ty=document.getElementById('pdf-thankyou');if(ty)ty.remove();
    btns.forEach(function(b){if(b.textContent.includes('Receipt'))b.style.display='';});
  }
}

function formatCompactUsd(n) {
  var num = Number(n);
  if (!isFinite(num)) return '$0';
  if (Math.abs(num) >= 1000000) return '$' + (num / 1000000).toFixed(2).replace(/\.00$/, '') + 'M';
  if (Math.abs(num) >= 1000) return '$' + (num / 1000).toFixed(2).replace(/\.00$/, '') + 'K';
  return '$' + num.toFixed(2);
}

async function navigateToOrder(orderIdOrNumber){
  showNavLoading(true);
  try{
    var order = await api('/admin/orders/'+orderIdOrNumber, true);
    if(!order){ throw new Error('Order not found'); }
    
    sessionStorage.setItem('pendingOrderView', JSON.stringify({
      id: order.id, orderNumber: order.orderNumber, shopName: order.shopName,
      location: order.location, timeInfo: order.timeInfo, status: order.status,
      paymentStatus: order.paymentStatus, date: order.date,
      deliveredAt: order.deliveredAt, cancelledAt: order.cancelledAt,
      brand: order.brand, lineItems: order.lineItems, discount: order.discount,
      shippingAddress: order.shippingAddress, subtotalPrice: order.subtotalPrice,
      totalPrice: order.totalPrice
    }));
    
    showView('order-detail');
    setTimeout(function(){ openOrderDetail(order.id); }, 100);
    
  }catch(err){
    console.error('Nav to order failed:', err);
    alert('Could not open order: ' + (err.message || 'Unknown error'));
    showView('orders');
    loadOrders();
  }finally{
    showNavLoading(false);
  }
}
async function navigateToRMA(rmaIdOrNumber){
  showNavLoading(true);
  try{
    var detail = await api('/admin/rma/'+rmaIdOrNumber, true);
    var rma = detail && detail.rma ? detail.rma : detail;
    if(!rma){ throw new Error('RMA not found'); }
    
    sessionStorage.setItem('pendingRmaView', JSON.stringify({
      rmaId: rma.id || rma._id, rmaNumber: rma.rmaNumber,
      orderNumber: rma.orderNumber || 'Order #'+rma.orderId,
      shopName: rma.shopName || '-', location: rma.location || '-',
      reason: rma.reason || '-', status: rma.status || 'pending',
      items: rma.lineItems || rma.line_items || [],
      requestedDate: rma.createdAt ? new Date(rma.createdAt).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'}) : '-'
    }));
    
    showView('rma-detail');
    setTimeout(function(){ openRMADetail(rma.id || rma._id); }, 100);
    
  }catch(err){
    console.error('Nav to RMA failed:', err);
    alert('Could not open RMA: ' + (err.message || 'Unknown error'));
    showView('rma');
    loadRMA();
  }finally{
    showNavLoading(false);
  }
}
async function navigateToTicket(ticketId){
  showNavLoading(true);
  try{
    var t = await api('/support/tickets/'+ticketId, true);
    if(!t || !t.id){ throw new Error('Ticket not found'); }
    
    sessionStorage.setItem('pendingTicketView', JSON.stringify({
      ticketId: t.id, shopName: t.shopName, subject: t.subject,
      description: t.description, status: t.status,
      createdDate: new Date(t.createdAt).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'}),
      assignedTo: t.assignedTo, priority: t.priority
    }));
    
    showView('support-detail');
    setTimeout(function(){ openSupportDetail(t.id); }, 100);
    
  }catch(err){
    console.error('Nav to ticket failed:', err);
    alert('Could not open ticket: ' + (err.message || 'Unknown error'));
    showView('support');
    loadSupport();
  }finally{
    showNavLoading(false);
  }
}
async function confirmResetTempPassword() {
  if(!_resetPassUserId) return;

  var btn = document.getElementById('reset-pass-submit-btn');
  var errEl = document.getElementById('reset-pass-error');

  btn.textContent = 'Sending…';
  btn.disabled = true;
  errEl.textContent = '';

  try {
    var res = await apiPost('/users/' + _resetPassUserId + '/reset-temp-password', {}, true);

    if(res && (res.success || res.message)) {
      closeModal('modal-reset-temp-pass');
      // Show success modal reusing existing delete-result modal
      var titleEl = document.getElementById('delete-result-title');
      var msgEl   = document.getElementById('delete-result-message');
      var iconEl  = document.getElementById('delete-result-icon');
      if(titleEl) titleEl.textContent = 'Done';
      if(msgEl)   msgEl.textContent   = res.message || 'A new temporary password has been sent to the user by email.';
      if(iconEl)  iconEl.textContent  = '✅';
      openModal('modal-delete-result');
      LOADED.users = false;
      loadUsers();
      // refresh detail view if open
      if(_resetPassUserId) openUserDetail(_resetPassUserId);
    } else {
      errEl.textContent = (res && res.message) || 'Failed to resend temporary password.';
      btn.textContent = 'Resend';
      btn.disabled = false;
    }
  } catch(e) {
    errEl.textContent = 'Something went wrong. Please try again.';
    btn.textContent = 'Resend';
    btn.disabled = false;
  }
}
// ===================== USER DETAIL =====================
async function openUserDetail(userId, isRequested){
  window.location.hash = 'user-detail/' + userId + (isRequested ? '/requested' : '');
  if(!userId||userId==='undefined'){console.error('Invalid userId:',userId);return;}
  showView('user-detail');
  var content=document.getElementById('user-detail-content');
  content.innerHTML='<div style="padding:40px;text-align:center;color:var(--text-secondary)">Loading user details...</div>';
  try{
    var user;
    if(isRequested){
      user=_usersReq.find(function(u){return(u._id||u.id)===userId;});
      if(!user){
        var res=await api('/account-requests/'+userId,true);
        user=res&&res._id?res:(res&&res.user?res.user:res);
      }
    }else{
      var res=await api('/users/'+userId,true);
      user=res&&res._id?res:(res&&res.user?res.user:res);
    }
    if(!user||(!user._id&&!user.id)){content.innerHTML='<div style="padding:40px;text-align:center;color:var(--chart-red)">User not found</div>';return;}
    window._currentUserDetail=user;
    window._currentUserIsRequested=!!isRequested;
    renderUserDetail(user, isRequested);
  }catch(e){content.innerHTML='<div style="padding:40px;text-align:center;color:var(--chart-red)">Error loading user<br><small>'+e.message+'</small></div>';}

}

async function toggleUser(id,active){await apiPatch('/users/'+id,{isActive:active},true);}

function openAddUser() {
  ['au-name','au-email','au-pass','au-phone','au-location'].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) el.value = '';
  });
  document.getElementById('au-error').textContent = '';

  // Detect role
  var role = (localStorage.getItem('userRole') || '').toLowerCase().trim();
  try { var _u = JSON.parse(localStorage.getItem('@exhaustexpert_user') || '{}'); if (_u && _u.role) role = _u.role.toLowerCase().trim(); } catch(e) {}
  var isSalesRep = (role === 'salesrep' || role === 'sales_rep');

  var typeGroup = document.getElementById('au-type-group');
  var shopGroup = document.getElementById('au-shop-group');
  var typeEl    = document.getElementById('au-type');

  if (isSalesRep) {
    // Hide user-type selector, force 'customer', always show shop dropdown
    if (typeGroup) typeGroup.style.display = 'none';
    if (typeEl)    typeEl.value = 'customer';
    if (shopGroup) shopGroup.style.display = 'block';

    // Load only this sales rep's shops
    var shopSel = document.getElementById('au-shop');
    if (shopSel) shopSel.innerHTML = '<option value="" disabled selected>Loading your shops...</option>';
    api('/shops', true).then(function(data) {
      var allShops = Array.isArray(data) ? data : (data && data.shops ? data.shops : []);
      var myId = '';
      try {
        var stored = JSON.parse(localStorage.getItem('@exhaustexpert_user') || '{}');
        myId = String(stored._id || stored.id || '').trim();
      } catch(e) {}
      var myShops = myId
        ? allShops.filter(function(s) {
            var repIds = Array.isArray(s.salesRepIds) ? s.salesRepIds.map(String) : [];
            var singleId = String(s.salesRepId || '');
            return repIds.indexOf(myId) > -1 || singleId === myId;
          })
        : allShops; 

      if (!myShops.length) {
        shopSel.innerHTML = '<option value="" disabled selected>No shops assigned to you</option>';
        document.getElementById('au-error').textContent = 'No shops are assigned to your account.';
      } else {
        shopSel.innerHTML = '<option value="" disabled selected>Select shop</option>' +
          myShops.map(function(s) {
            return '<option value="' + (s._id || s.id) + '">' + s.shopName + '</option>';
          }).join('');
      }
    }).catch(function() {
      var shopSel = document.getElementById('au-shop');
      if (shopSel) shopSel.innerHTML = '<option value="" disabled selected>Error loading shops</option>';
    });

  } else {
    if (typeGroup) typeGroup.style.display = 'block';
    if (typeEl)    typeEl.value = '';
    if (shopGroup) shopGroup.style.display = 'none';
  }

  openModal('modal-add-user');
}
// ===================== SUPPORT =====================
async function loadSupport(){var data=await api('/support/tickets',true);_support=Array.isArray(data)?data:(data&&data.tickets?data.tickets:[]);renderSupport(applySupportFilters(_support));}
function applySupportFilters(list){
  var q=(document.getElementById('support-search')||{}).value||'';q=q.toLowerCase();
  var st=((document.getElementById('support-status-sel')||{}).value||'').toLowerCase();
  if(q) list=list.filter(function(t){var shop=String(t.shopName||t.shop||'').toLowerCase();var subj=String(t.subject||t.message||'').toLowerCase();return shop.includes(q)||subj.includes(q);});
  if(st) list=list.filter(function(t){return String(t.status||'').toLowerCase()===st;});
  list=applyDateFilter('support',list,function(t){return t.createdAt||t.created_at||t.date||'';});
  return list;
}
function filterSupport(){renderSupport(applySupportFilters(_support));}
function renderSupport(list){
  document.getElementById('support-count').textContent=list.length;
  var tbody=document.getElementById('support-body');
  if(!list.length){tbody.innerHTML='<tr><td colspan="3"><div class="empty-state"><span class="empty-icon">💬</span><p>No tickets found</p></div></td></tr>';return;}
  tbody.innerHTML=list.map(function(t){
    var realId=t.id||t._id;var shop=t.shopName||t.shop||'-';var subj=t.subject||t.message||'-';
    if(subj.length>36)subj=subj.substring(0,36)+'...';
    var stat=(t.status||'open').toLowerCase();
    var badgeCls=stat==='in_progress'?'badge-inprogress':'badge-'+stat;
    var statLabel=stat==='in_progress'?'In Progress':(stat.charAt(0).toUpperCase()+stat.slice(1));
    return'<tr style="cursor:pointer" onclick="openSupportDetail(\''+realId+'\')"><td style="padding:12px 16px;color:#4fc3f7">'+shop+'</td><td style="padding:12px 16px">'+subj+'</td><td style="padding:12px 16px"><span class="badge '+badgeCls+'">'+statLabel+'</span></td></tr>';
  }).join('');
}
async function openSupportDetail(id){
  window.location.hash = 'support-detail/' + id;
  if(!id)return;_currentSupportId=id;
  showView('support-detail');
  var content=document.getElementById('support-detail-content');
  content.innerHTML='<div style="padding:40px;text-align:center;color:var(--text-secondary)">Loading ticket details...</div>';
  try{
    var res=await api('/support/tickets/'+id,true);
    var data=res&&res.id?res:(res&&res.ticket?res.ticket:res);
    if(!data){content.innerHTML='<div style="padding:40px;text-align:center;color:var(--chart-red)">No ticket data found</div>';return;}
    renderSupportDetail(data);
  }catch(e){content.innerHTML='<div style="padding:40px;text-align:center;color:var(--chart-red)">Error loading ticket: '+e.message+'</div>';}
}
function renderSupportDetail(t){
  var ticketId=t.ticketId||t.ticket_id||t.id||'-';
  var status=(t.status||'open').toLowerCase();
  var badgeCls='badge-'+status.replace(/_/g,'');
  if(status==='in_progress')badgeCls='badge-inprogress';
  else if(status==='open')badgeCls='badge-open';
  else if(status==='resolved')badgeCls='badge-resolved';
  else if(status==='closed')badgeCls='badge-closed';
  var statusText=status==='in_progress'?'In Progress':(status.charAt(0).toUpperCase()+status.slice(1));
  var shopName=t.shopName||t.shop||'-';var createdDate=fmtDateTime(t.createdAt||t.created_at||t.date);
  var assignedTo=t.assignedTo||t.assigned_to||t.assignee||'-';var subject=t.subject||'-';
  var isClosed=status==='closed';
  var msgs=t.messages||t.conversation||t.comments||[];var convHTML='';
  if(msgs.length){convHTML=msgs.map(function(m){
    var senderType=m.senderType||m.sender||m.from||m.role||m.author||'customer';
    var senderName=m.senderName||m.sender||m.from||m.author||'Unknown';
    var text=m.body||m.message||m.text||m.content||'';
    var time=fmtDateTime(m.createdAt||m.timestamp||m.date);
    var cls='customer';
    var senderTypeLower=String(senderType).toLowerCase();
    if(senderTypeLower.includes('admin'))cls='admin';
    else if(senderTypeLower.includes('sales'))cls='salesrep';
    var displayName='';
    if(cls==='admin'){
      displayName='You';
    }
    else{
      displayName=senderName+' ('+senderType.charAt(0).toUpperCase()+senderType.slice(1)+')';
    }
    return'<div style="display:flex;flex-direction:column;align-items:'+(cls==='admin'?'flex-end':'flex-start')+';">'+
      '<div class="conv-msg '+cls+'"><div class="conv-msg-sender">'+displayName+'</div><div>'+text+'</div><div class="conv-msg-time">'+time+'</div></div></div>';
  }).join('');}
  else{convHTML='<div class="conv-empty">No messages yet.</div>';}
  var html=
    '<div class="detail-header-card"><div style="display:flex;align-items:center;gap:12px;margin-bottom:12px;"><div style="width:44px;height:44px;background:var(--bg-secondary);border-radius:10px;display:flex;align-items:center;justify-content:center;"><svg width="22" height="22" fill="none" stroke="var(--sidebar-accent2)" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/></svg></div><div><div style="font-size:18px;font-weight:700;color:var(--text-primary)">Ticket #'+ticketId+'</div><span class="badge '+badgeCls+'" style="margin-top:4px;padding:4px 12px;font-size:12px;">'+statusText+'</span></div></div></div>'+
    '<div style="font-size:16px;font-weight:700;color:var(--text-primary);margin:0 0 12px;">Ticket Information</div>'+
    '<div class="detail-section-card" style="margin-bottom:20px;"><div class="detail-row"><div style="display:flex;align-items:center;gap:8px;"><svg width="14" height="14" fill="none" stroke="var(--text-muted)" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5"/></svg><span class="detail-row-label">Shop Name</span></div><span class="detail-row-value">'+shopName+'</span></div>'+
    (subject&&subject!=='-'?'<div class="detail-row"><div style="display:flex;align-items:center;gap:8px;"><svg width="14" height="14" fill="none" stroke="var(--text-muted)" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"/></svg><span class="detail-row-label">Subject</span></div><span class="detail-row-value" style="max-width:60%;text-align:right">'+subject+'</span></div>':'')+
    '<div class="detail-row"><div style="display:flex;align-items:center;gap:8px;"><svg width="14" height="14" fill="none" stroke="var(--text-muted)" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg><span class="detail-row-label">Created Date</span></div><span class="detail-row-value">'+createdDate+'</span></div>'+
    '<div class="detail-row"><div style="display:flex;align-items:center;gap:8px;"><svg width="14" height="14" fill="none" stroke="var(--text-muted)" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/></svg><span class="detail-row-label">Assigned To</span></div><span class="detail-row-value">'+assignedTo+'</span></div></div>'+
    '<div class="conv-section"><div class="conv-title" style="font-size:18px;margin-bottom:16px;">Conversation</div><div class="conv-msgs" id="support-conv-msgs">'+convHTML+'</div>'+
    (!isClosed?'<div class="reply-input-row"><textarea class="reply-input" id="support-reply-input" placeholder="Type a reply..." rows="2"></textarea><button class="reply-send-btn" onclick="sendSupportReply()"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/></svg></button></div>':'<div style="padding:12px;text-align:center;color:var(--text-muted);font-size:13px;">This ticket is closed.</div>')+
    '</div>'+
    (!isClosed?'<div class="detail-actions" style="margin-top:16px;width:33%"><button class="detail-action-btn teal" onclick="openUpdateSupportStatus()">Update Status</button><button class="detail-action-btn teal" onclick="openAssignSalesrepSupport()">Assign Salesrep</button></div>':'');
  document.getElementById('support-detail-content').innerHTML=html;
  window._currentSupportData=t;
}
function openUpdateSupportStatus(){var status=(window._currentSupportData&&window._currentSupportData.status)||'open';document.getElementById('support-new-status').value=status;document.getElementById('support-status-error').textContent='';openModal('modal-update-support-status');}
async function submitSupportStatus(){var newStatus=document.getElementById('support-new-status').value;var btn=document.getElementById('support-status-submit-btn');btn.textContent='Updating...';btn.disabled=true;

var res=await apiPatch('/support/tickets/'+_currentSupportId,{status:newStatus},true);
btn.textContent='Update';btn.disabled=false;if(res&&(res.id||res.status||res.subject||res.success||res.message)){closeModal('modal-update-support-status');openSupportDetail(_currentSupportId);LOADED.support=false;loadSupport();}else{document.getElementById('support-status-error').textContent=(res&&res.message)||'Failed to update status.';}}
async function sendSupportReply(){var inp=document.getElementById('support-reply-input');var msg=(inp&&inp.value||'').trim();if(!msg)return;inp.value='';

var res=await apiPost('/support/tickets/'+_currentSupportId+'/messages',{body:msg,isInternal:false},true);
if(res&&(res.id||res.body||res.success)){openSupportDetail(_currentSupportId);}else{var msgs=document.getElementById('support-conv-msgs');if(msgs){var div=document.createElement('div');div.style.cssText='display:flex;flex-direction:column;align-items:flex-end;';div.innerHTML='<div class="conv-msg admin"><div class="conv-msg-sender">Admin</div><div>'+msg+'</div><div class="conv-msg-time">Just now</div></div>';msgs.appendChild(div);}}}

async function syncWarehouses(event) {
  var btn = event && event.target ? event.target : null;
  if (btn) {
    btn.textContent = 'Syncing...';
    btn.disabled = true;
  }
  
  try {
    var res = await apiPost('/warehouses/sync-from-portal', {}, true);
    console.log('Sync response:', res);
    var syncOk = false;
    var errorMessage = null;
    var stats = null;
    
    if (res && typeof res === 'object') {
      if (res.success === true || res.ok === true || res.syncOk === true) {
        syncOk = true;
        stats = res.stats || res.data || res;
      }
      else if (res.success === false || res.ok === false || res.syncOk === false) {
        syncOk = false;
        errorMessage = res.errorMessage || res.message || res.error || 'Sync failed';
      }
      else if (res.fetched != null || res.warehousesUpserted != null) {
        syncOk = true;
        stats = res;
      }
    }
    
    if (!syncOk) {
      showAlertModal('Sync Failed', errorMessage || 'Could not sync warehouses from portal.');
      return;
    }
    if (stats) {
      var message = 'Fetched: ' + (stats.fetched || 0) + '\n' +
        'Warehouses upserted: ' + (stats.warehousesUpserted || 0) + '\n' +
        'Admins created: ' + (stats.adminsCreated || 0) + '\n' +
        'Admins updated: ' + (stats.adminsUpdated || 0) + '\n' +
        'Skipped (no email): ' + (stats.skippedNoEmail || 0) + '\n' +
        'Skipped (conflict): ' + (stats.skippedConflict || 0) + '\n' +
        'Skipped (admin email): ' + (stats.skippedAdminEmail || 0);
      showAlertModal('Sync Complete', message);
    } else {
      showAlertModal('Sync Complete', 'Warehouses were synced from the portal.');
    }
    
    // Refresh warehouses list if needed
    if (typeof loadShops === 'function') {
      LOADED.shops = false;
      loadShops();
    }
    
  } catch (e) {
    console.error('Sync error:', e);
    showAlertModal('Error', 'Sync failed. Please try again.');
  } finally {
    if (btn) {
      btn.textContent = 'Sync Warehouses from Portal';
      btn.disabled = false;
    }
  }
}

function showAlertModal(title, message) {
  // Create modal if it doesn't exist
  var modalId = 'sync-alert-modal';
  var existing = document.getElementById(modalId);
  if (existing) existing.remove();
  
  var modal = document.createElement('div');
  modal.id = modalId;
  modal.className = 'modal-overlay active';
  modal.innerHTML = 
    '<div class="modal-box" style="max-width:420px">' +
      '<div class="modal-header">' +
        '<div class="modal-title">' + escHtml(title) + '</div>' +
        '<button class="modal-close" onclick="this.closest(\'.modal-overlay\').remove()">×</button>' +
      '</div>' +
      '<div style="padding:20px 0;text-align:center">' +
        '<p style="color:var(--text-secondary);margin:0;white-space:pre-wrap">' + escHtml(message) + '</p>' +
      '</div>' +
      '<div class="modal-footer">' +
        '<button class="action-btn primary" onclick="this.closest(\'.modal-overlay\').remove()" style="width:100%">OK</button>' +
      '</div>' +
    '</div>';
  
  // Close on overlay click
  modal.onclick = function(e) {
    if (e.target === modal) modal.remove();
  };
  
  // Close on Escape key
  var onKey = function(e) {
    if (e.key === 'Escape') {
      modal.remove();
      document.removeEventListener('keydown', onKey);
    }
  };
  document.addEventListener('keydown', onKey);
  
  document.body.appendChild(modal);
}

function buildSalesTrendBars(period, orders) {
  var now = new Date();
  
  // ─── WTD (Week to Date) ───
  if (period === 'wtd' || period === 'week') {
    var day = now.getDay();
    var diffToMonday = day === 0 ? 6 : day - 1;
    var monday = new Date(now);
    monday.setDate(now.getDate() - diffToMonday);
    monday.setHours(0, 0, 0, 0);
    var dayLabels = ['M','T','W','T','F','S','S'];
    return dayLabels.slice(0, diffToMonday + 1).map(function(lbl, i) {
      var start = new Date(monday); start.setDate(monday.getDate() + i);
      var end   = new Date(start);  end.setDate(start.getDate() + 1);
      var value = orders.reduce(function(sum, o) {
        var d = new Date(o.date || o.created_at || o.createdAt || '');
        return (d >= start && d < end) ? sum + getOrderTotal(o) : sum;
      }, 0);
      return {label: lbl, value: Math.round(value)};
    });
  }
  
  // ─── MTD (Month to Date) ───
  if (period === 'mtd' || period === 'month') {
    var ticks = [1, 5, 10, 15, 20, 25].filter(function(t) { return t <= now.getDate(); });
    if (!ticks.length) ticks = [1];
    return ticks.map(function(t, idx) {
      var startDay = t;
      var endDay   = idx < ticks.length - 1 ? ticks[idx + 1] - 1 : now.getDate();
      var start = new Date(now.getFullYear(), now.getMonth(), startDay, 0, 0, 0, 0);
      var end   = new Date(now.getFullYear(), now.getMonth(), endDay,  23,59,59,999);
      var value = orders.reduce(function(sum, o) {
        var d = new Date(o.date || o.created_at || o.createdAt || '');
        return (d >= start && d <= end) ? sum + getOrderTotal(o) : sum;
      }, 0);
      return {label: String(t), value: Math.round(value)};
    });
  }
  
  // ─── YTD (Year to Date) ───
  if (period === 'ytd' || period === 'year') {
    var months = [];
    for (var m = 0; m <= now.getMonth(); m++) months.push(m);
    return months.map(function(m) {
      var start = new Date(now.getFullYear(), m, 1, 0, 0, 0, 0);
      var end   = new Date(now.getFullYear(), m + 1, 0, 23, 59, 59, 999);
      var value = orders.reduce(function(sum, o) {
        var d = new Date(o.date || o.created_at || o.createdAt || '');
        return (d >= start && d <= end) ? sum + getOrderTotal(o) : sum;
      }, 0);
      var lbl = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][m];
      return {label: lbl, value: Math.round(value)};
    });
  }
  // 1. Define the 'end' point as start of current month
  var endMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  
  // 2. Generate start dates going back 12 months in steps of 3 (12, 9, 6, 3, 0)
  var starts = [];
  for (var i = 12; i >= 0; i -= 3) {
    var d = new Date(endMonthStart);
    d.setMonth(d.getMonth() - i);
    starts.push(new Date(d.getFullYear(), d.getMonth(), 1));
  }
  
  // 3. Build ranges
  var monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  
  var ranges = starts.map(function(s, idx) {
    var nextStart = starts[idx + 1];
    var e = idx < starts.length - 1 
      ? new Date(nextStart.getFullYear(), nextStart.getMonth(), 0, 23, 59, 59, 999)
      : new Date(now);
    return { start: s, end: e };
  });
  
  // 4. Calculate values and filter out future dates
  return ranges.map(function(r) {
    if (r.start > now) return null;
    
    var value = orders.reduce(function(sum, o) {
      var d = new Date(o.date || o.created_at || o.createdAt || '');
      return (d >= r.start && d <= r.end) ? sum + getOrderTotal(o) : sum;
    }, 0);
    var lbl = monthNames[r.start.getMonth()] + " '" + String(r.start.getFullYear()).slice(-2);
    
    return {label: lbl, value: Math.round(value)};
  }).filter(function(item) { return item !== null; }); 
}

function buildSalesTrendData(period, orders) {
  var now = new Date();
  var filtered = filterOrdersByPeriod(orders, period, 'date');

  // ─── WTD (Week to Date) ───
  if (period === 'wtd') {
    var day = now.getDay();
    var diff = day === 0 ? 6 : day - 1;
    var mon = new Date(now); mon.setDate(now.getDate() - diff); mon.setHours(0,0,0,0);
    var labels = ['M','T','W','T','F','S','S'];
    return labels.slice(0, diff+1).map(function(l, i) {
      var s = new Date(mon); s.setDate(mon.getDate() + i);
      var e = new Date(s); e.setDate(s.getDate() + 1);
      var val = filtered.reduce(function(acc, o) { var d = new Date(o.date||o.created_at||''); return d>=s && d<e ? acc+getSalesOrderTotal(o) : acc; }, 0);
      return {label: l, value: Math.round(val)};
    });
  }

  // ─── MTD (Month to Date) ───
  if (period === 'mtd') {
    var ticks = [1,5,10,15,20,25].filter(function(t){return t<=now.getDate();});
    if(!ticks.length) ticks=[1];
    return ticks.map(function(t, idx) {
      var sd=t, ed=idx<ticks.length-1?ticks[idx+1]-1:now.getDate();
      var s=new Date(now.getFullYear(),now.getMonth(),sd,0,0,0,0);
      var e=new Date(now.getFullYear(),now.getMonth(),ed,23,59,59,999);
      var val = filtered.reduce(function(acc, o) { var d=new Date(o.date||o.created_at||''); return d>=s && d<=e ? acc+getSalesOrderTotal(o) : acc; }, 0);
      return {label: String(t), value: Math.round(val)};
    });
  }

  // ─── YTD (Year to Date) ───
  if (period === 'ytd') {
    var res = [];
    for(var m=0; m<=now.getMonth(); m++) {
      var s=new Date(now.getFullYear(),m,1,0,0,0,0);
      var e=new Date(now.getFullYear(),m+1,0,23,59,59,999);
      var val = filtered.reduce(function(acc, o) { var d=new Date(o.date||o.created_at||''); return d>=s && d<=e ? acc+getSalesOrderTotal(o) : acc; }, 0);
      res.push({label: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][m], value: Math.round(val)});
    }
    return res;
  }

  var endMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  var starts = [];
  for (var i = 12; i >= 0; i -= 3) {
    var d = new Date(endMonthStart);
    d.setMonth(d.getMonth() - i);
    starts.push(new Date(d.getFullYear(), d.getMonth(), 1));
  }

  var monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  var ranges = starts.map(function(s, idx) {
    var nextStart = starts[idx + 1];
    var e = idx < starts.length - 1 
      ? new Date(nextStart.getFullYear(), nextStart.getMonth(), 0, 23, 59, 59, 999)
      : new Date(now);
    return { start: s, end: e };
  });

  return ranges.map(function(r) {
    if (r.start > now) return null;
    
    var value = filtered.reduce(function(acc, o) { 
      var d=new Date(o.date||o.created_at||''); 
      return d>=r.start && d<=r.end ? acc+getSalesOrderTotal(o) : acc; 
    }, 0);
    var lbl = monthNames[r.start.getMonth()] + " '" + String(r.start.getFullYear()).slice(-2);
    
    return {label: lbl, value: Math.round(value)};
  }).filter(function(item) { return item !== null; }); 
}
function capitalizeFirst(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function chartDateSetType(chart,type){
  _chartDateState[chart].dateType=type;
  if(type==='equal')_chartDateState[chart].date2='';
  refreshChartDropdown(chart);
  var ddMap={orders:'dd-oc',rma:'dd-rc',support:'dd-sc',sales:'dd-stc'};
  document.getElementById(ddMap[chart]).classList.add('open');
}

function chartDateSet1(chart,val){
  _chartDateState[chart].date1=val;
  if(_chartDateState[chart].dateType==='between'&&_chartDateState[chart].date2&&_chartDateState[chart].date2<val)_chartDateState[chart].date2='';
  refreshChartDropdown(chart);
  var ddMap={orders:'dd-oc',rma:'dd-rc',support:'dd-sc',sales:'dd-stc'};
  document.getElementById(ddMap[chart]).classList.add('open');
}

function chartDateSet2(chart,val){
  var ds=_chartDateState[chart];
  if(ds.date1&&val<ds.date1){ds.date2='';}else{ds.date2=val;}
  refreshChartDropdown(chart);
  var ddMap={orders:'dd-oc',rma:'dd-rc',support:'dd-sc',sales:'dd-stc'};
  document.getElementById(ddMap[chart]).classList.add('open');
}

function chartDateApply(chart){
  var ds=_chartDateState[chart];
  var d1el=document.getElementById('cdf-d1-'+chart);
  var d2el=document.getElementById('cdf-d2-'+chart);
  if(d1el)ds.date1=d1el.value;
  if(d2el)ds.date2=d2el.value;
  if(!ds.date1)return;
  if(ds.dateType==='between'&&ds.date2&&ds.date2<ds.date1)return;
  var ddMap={orders:'dd-oc',rma:'dd-rc',support:'dd-sc',sales:'dd-stc'};
  // document.getElementById(ddMap[chart]).classList.remove('open');
  // _redrawChartNew(chart);
  document.getElementById(ddMap[chart]).classList.remove('open');

if(chart === 'sales'){
  updateSalesTrendXLabel(_chartPeriods['sales']);
}

_redrawChartNew(chart);
}

function chartDateReset(chart){
  _chartPeriods[chart]='all';
  _chartDateState[chart]={dateType:'equal',date1:'',date2:''};
  var ddMap={orders:'dd-oc',rma:'dd-rc',support:'dd-sc',sales:'dd-stc'};
  // refreshChartDropdown(chart);
  // document.getElementById(ddMap[chart]).classList.remove('open');
  // _redrawChartNew(chart);
  refreshChartDropdown(chart);

if(chart === 'sales'){
  updateSalesTrendXLabel('all');
}

document.getElementById(ddMap[chart]).classList.remove('open');
_redrawChartNew(chart);
}
async function submitAddShop(){
  var name=document.getElementById('sh-name').value.trim();
  var phone=document.getElementById('sh-phone').value.trim();
  var email=document.getElementById('sh-email').value.trim();
  var errEl=document.getElementById('sh-error');
  var addresses=[];
  for(var i=0;i<_addrCount;i++){
    var el=document.getElementById('sh-addr-'+i);
    if(el&&el.value.trim())addresses.push(el.value.trim());
  }

  // Detect role
  var role = (localStorage.getItem('userRole') || '').toLowerCase().trim();
  try { var u = JSON.parse(localStorage.getItem('@exhaustexpert_user')||'{}'); if(u && u.role) role = u.role.toLowerCase().trim(); } catch(e){}
  var isSalesRep = (role === 'salesrep' || role === 'sales_rep');

  // ✅ Base Validation (Required for BOTH)
  if(!name || !email || !addresses.length){
    errEl.textContent='Please fill all required fields.';
    return;
  }

  // ✅ Admin Validation
  if(!isSalesRep){
    var salesRep=document.getElementById('sh-salesrep').value;
    var warehouse=document.getElementById('sh-warehouse').value;
    if(!salesRep || !warehouse){
      errEl.textContent='Please select Sales Rep and Warehouse.';
      return;
    }
  }

  errEl.textContent='';
  var btn=document.getElementById('sh-submit-btn');
  btn.textContent='Adding...'; btn.disabled=true;

  // ✅ Payload: ONLY 4 fields for SalesRep
  var payload = {
    shopName: name,
    phoneNumber: phone,
    email: email,
    physicalLocation: addresses[0]
  };
  if(addresses.length>1) payload.additionalAddresses = addresses.slice(1);

  // ✅ Add extra fields ONLY for Admin
  if(!isSalesRep){
    payload.salesRepId = document.getElementById('sh-salesrep').value;
    payload.warehouseId = document.getElementById('sh-warehouse').value;
  }

  var res=await apiPost('/shops',payload,true);
  btn.textContent='Add Shop'; btn.disabled=false;

  if(res&&(res.success||res._id||res.id||res.shopName)){
    closeModal('modal-add-shop');
    LOADED.shops=false;
    loadShops();
  }else{
    errEl.textContent=(res&&(Array.isArray(res.message)?res.message.join(' '):res.message))||'Failed to add shop.';
  }
}

function _redrawChartNew(chart){
  if(chart==='orders'){
    var f=filterByChartDate('orders',_rawDashData.orders,function(o){return o.date||o.created_at||o.createdAt||'';});
    var ip=0,dl=0,cl=0;
    f.forEach(function(o){var s=(o.status||'').toLowerCase().replace(/[\s-]/g,'_');if(s==='delivered'||s==='fulfilled'||s==='completed')dl++;else if(s==='cancelled'||s==='canceled')cl++;else ip++;});
    drawBar('bc-oc','ya-oc','gl-oc','lbl-oc',[{label:'In Progress',value:ip},{label:'Delivered',value:dl},{label:'Cancelled',value:cl}],['blue','green','red'],getChartTimeLabel('orders'));
  }
  if(chart==='rma'){
    var f=filterByChartDate('rma',_rawDashData.rmas,function(r){return r.createdAt||r.date||'';});
    var p=0,pr=0,c=0;
    f.forEach(function(r){var s=(r.status||'').toUpperCase().trim(),rs=(r.refundStatus||'').toUpperCase().trim();if(['REFUNDED','CLOSED','COMPLETED','INSPECTED'].indexOf(s)>-1||rs==='SUCCEEDED')c++;else if(['REQUESTED','UNDER_REVIEW','PENDING'].indexOf(s)>-1)p++;else pr++;});
    drawBar('bc-rc','ya-rc','gl-rc','lbl-rc',[{label:'Pending',value:p},{label:'Processing',value:pr},{label:'Completed',value:c}],['yellow','teal','green'],getChartTimeLabel('rma'));
  }
  if(chart==='support'){
    var f = filterByChartDate('support', _rawDashData.support, function(t){ return t.createdAt||t.created_at||t.date||''; });
    var period = _chartPeriods['support'];
    var now = new Date(), labels = [], counts = [];

    if(period === 'wtd' || period === 'week'){
      var day = now.getDay(), diff = day===0?6:day-1;
      var mon = new Date(now); mon.setDate(now.getDate()-diff); mon.setHours(0,0,0,0);
      var dayLetters = ['M','T','W','T','F','S','S'];
      for(var i=0; i<=diff; i++){
        var s = new Date(mon); s.setDate(mon.getDate()+i); s.setHours(0,0,0,0);
        var e = new Date(s); e.setDate(s.getDate()+1);
        labels.push(dayLetters[i]||'');
        counts.push(f.filter(function(t){ var d=new Date(t.createdAt||t.created_at||t.date||''); return !isNaN(d)&&d>=s&&d<e; }).length);
      }
    } else if(period === 'mtd' || period === 'month'){
      var cursor = new Date(now.getFullYear(), now.getMonth(), 1);
      while(cursor <= now){
        var ws = new Date(cursor);
        var we = new Date(cursor); we.setDate(cursor.getDate()+6); we.setHours(23,59,59,999);
        if(we > now) we = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23,59,59,999);
        var wsSnap = new Date(ws);
        var weSnap = new Date(we);
        labels.push(ws.toLocaleDateString('en-US',{month:'short', day:'numeric'}));
        counts.push(f.filter(function(t){ var d=new Date(t.createdAt||t.created_at||t.date||''); return !isNaN(d)&&d>=wsSnap&&d<=weSnap; }).length);
        cursor.setDate(cursor.getDate()+7);
      }
    } else if(period === 'ytd' || period === 'year'){
      for(var m=0; m<=now.getMonth(); m++){
        var mStart = new Date(now.getFullYear(), m, 1, 0,0,0,0);
        var mEnd   = new Date(now.getFullYear(), m+1, 0, 23,59,59,999);
        var mS = new Date(mStart), mE = new Date(mEnd);
        labels.push(mStart.toLocaleDateString('en-US',{month:'short'}));
        counts.push(f.filter(function(t){ var d=new Date(t.createdAt||t.created_at||t.date||''); return !isNaN(d)&&d>=mS&&d<=mE; }).length);
      }
    } else {
      for(var i=4; i>=0; i--){
        var ws = new Date(now); ws.setDate(now.getDate()-i*7); ws.setHours(0,0,0,0);
        var we = new Date(ws); we.setDate(ws.getDate()+6); we.setHours(23,59,59,999);
        var wsSnap = new Date(ws), weSnap = new Date(we);
        labels.push(ws.toLocaleDateString('en-US',{month:'short',day:'numeric'}));
        counts.push(f.filter(function(t){ var d=new Date(t.createdAt||t.created_at||t.date||''); return !isNaN(d)&&d>=wsSnap&&d<=weSnap; }).length);
      }
    }

    drawLine('lc-sc','ya-sc','gl-sc','lbl-sc',{values:counts,labels:labels},getChartTimeLabel('support'));
    updateSupportTrendXLabel(period);
  }
if(chart==='sales'){
    var f=filterByChartDate('sales',_rawDashData.orders,function(o){return o.date||o.created_at||o.createdAt||'';});
    var period=_chartPeriods['sales'];
    var bars=period==='date'?_buildSalesBarsForDate(f):buildSalesTrendBars(period,f);
    drawBar('bc-stc','ya-stc','gl-stc','lbl-stc',bars,Array(bars.length).fill('green'),getChartTimeLabel('sales'),formatCompactUsd);
    // Dashboard Sales Trend x-label (independent from Sales tab)
    var dashLabelMap = {
      wtd:'Day', week:'Day',
      mtd:'Day of Month', month:'Day of Month',
      ytd:'Month', year:'Month',
      all:'Quarter', date:'Date'
    };
    var elDashStc = document.getElementById('xl-dash-stc');
    if(elDashStc) elDashStc.textContent = dashLabelMap[period] || 'Quarter';
  }
}

function updateSupportTrendXLabel(period) {
  // var labelMap = {
  //   wtd: 'Day',
  //   mtd: 'Week',
  //   ytd: 'Month',
  //   all: 'Week',
  //   date: 'Date'
  // };
  var labelMap = {
    wtd: 'Day',
    week: 'Day',
    mtd: 'Week',
    month: 'Week',
    ytd: 'Month',
    year: 'Month',
    all: 'Week',
    date: 'Date'
  };
  var label = labelMap[period] || 'Week';
  var el = document.getElementById('xl-sc');
  if (el) {
    el.textContent = label;
  }
  setTimeout(function(){
    var el2 = document.getElementById('xl-sc');
    if(el2) el2.textContent = label;
  }, 150);
}


function redrawSupportChart() {
  var period   = _chartPeriods.support;
  var filtered = filterOrdersByPeriod(_rawDashData.support, period, 'createdAt');
  var now      = new Date();
  var labels   = [];
  var counts   = [];
  for (var i = 4; i >= 0; i--) {
    var weekStart = new Date(now);
    weekStart.setDate(now.getDate() - i * 7);
    weekStart.setHours(0, 0, 0, 0);
    var weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6);
    weekEnd.setHours(23, 59, 59, 999);
    labels.push(weekStart.toLocaleDateString('en-US', {month: 'short', day: 'numeric'}));
    var c = filtered.filter(function(t) {
      var raw = t.createdAt || t.created_at || t.date || t.updatedAt || '';
      if (!raw) return false;
      var created = new Date(raw);
      return !isNaN(created.getTime()) && created >= weekStart && created <= weekEnd;
    }).length;
    counts.push(c);
  }
  drawLine('lc-sc', 'ya-sc', 'gl-sc', 'lbl-sc',
    {values: counts, labels: labels},
    TL[period] || 'ALL TIME'
  );
}
function updateSalesTrendXLabel(period) {
  var labelMap = {
    wtd: 'Day',
    week: 'Day',

    mtd: 'Day of Month',
    month: 'Day of Month',

    ytd: 'Month',
    year: 'Month',

    all: 'Quarter',
    date: 'Date'
  };

  var label = labelMap[period] || 'Quarter';

  var elSales = document.getElementById('xl-sales');
  var elStc   = document.getElementById('xl-stc');

  if(elSales) elSales.textContent = label;
  if(elStc)   elStc.textContent   = label;
}